import { apiSlice } from "../../api/apiSlice";

export const itUsersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getItUsers: builder.query({
      query: () => ({
        url: "/api/user/it-users",
        method: "GET",
      }),
      providesTags: ["ItUser"],
    }),
    createItUser: builder.mutation({
      query: (body) => ({
        url: "/api/user/it-users",
        method: "POST",
        body,
      }),
      invalidatesTags: ["ItUser"],
    }),
    setItUserActive: builder.mutation({
      query: ({ id, isActive }) => ({
        url: `/api/user/it-users/${id}/active`,
        method: "PATCH",
        body: { isActive },
      }),
      invalidatesTags: ["ItUser"],
    }),
    deleteItUser: builder.mutation({
      query: (id) => ({
        url: `/api/user/it-users/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["ItUser"],
    }),
    setItUserPassword: builder.mutation({
      query: ({ id, password }) => ({
        url: `/api/user/it-users/${id}/password`,
        method: "PATCH",
        body: { password },
      }),
      invalidatesTags: ["ItUser"],
    }),
  }),
});

export const {
  useGetItUsersQuery,
  useCreateItUserMutation,
  useSetItUserActiveMutation,
  useDeleteItUserMutation,
  useSetItUserPasswordMutation,
} = itUsersApiSlice;
